import React from 'react';
import { PhoneInput } from './PhoneInput';

export interface FormInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  icon?: string;
  trailingIcon?: React.ReactNode;
  error?: string;
  showPasswordToggle?: boolean;
  inputRef?: React.Ref<HTMLInputElement>;
  helpText?: React.ReactNode;
}

export function FormInput({
  label,
  icon,
  trailingIcon,
  error,
  showPasswordToggle,
  helpText,
  type = 'text',
  className = '',
  id,
  inputRef,
  children,
  ...props
}: FormInputProps) {
  const [showPassword, setShowPassword] = React.useState(false);
  const inputId = id || props.name;
  const inputType = showPasswordToggle && showPassword ? 'text' : type;

  return (
    <div className="mb-4">
      {label && (
        <label htmlFor={inputId} className="form-label fw-semibold">
          {label}
        </label>
      )}
      {type === 'tel' ? <PhoneInput aria-label={label || props.placeholder} id={inputId} className={`${error ? 'is-invalid' : ''} ${className}`} {...props} /> : <div className={icon || trailingIcon || showPasswordToggle ? 'input-group' : ''}>
        {icon && (
          <span className="input-group-text">
            <i className={`feather-${icon}`}></i>
          </span>
        )}
        <input
          ref={inputRef}
          id={inputId}
          type={inputType}
          className={`form-control ${error ? 'is-invalid' : ''} ${className}`}
          {...props}
        />
        {trailingIcon && (
          <span className="input-group-text">{trailingIcon}</span>
        )}
        {showPasswordToggle && (
          <button
            type="button"
            className="input-group-text c-pointer"
            onClick={() => setShowPassword(!showPassword)}
            tabIndex={-1}
          >
            <i className={`feather-${showPassword ? 'eye-off' : 'eye'}`}></i>
          </button>
        )}
      </div>}
      {children}
      {error && <div className="invalid-feedback d-block">{error}</div>}
      {helpText && <div className="form-text">{helpText}</div>}
    </div>
  );
}
